import { familyMemberConstant } from "../constants/familyMember.constants";

const initialState = {
    members: [],
    relations: [], // Initialize relations as an empty array
    loading: false,
    error: null,
    deleteFamilyMember: false,
};

export function familyMembers(state = initialState, action) {
    switch (action.type) {
        case familyMemberConstant.FAMILY_MEMBER_LIST_REQUEST:
            return {
                loading: true,
            };
        case familyMemberConstant.FAMILY_MEMBER_LIST_SUCCESS:
            return {
                members: action.res,
                loading: false,
                deleteFamilyMember: false,
            };
        case familyMemberConstant.FAMILY_MEMBER_LIST_FAILURE:
            return {
                error: action.error,
                loading: false,
            };
        case familyMemberConstant.RELATION_LIST_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case familyMemberConstant.RELATION_LIST_SUCCESS:
            return {
                relations: action.res,
                loading: false,
            };
        case familyMemberConstant.RELATION_LIST_FAILURE:
            return {
                ...state,
                error: action.error,
                loading: false,
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/store/reducers/familyMember.reducer.js